import { MatPaginatorIntl } from '@angular/material/paginator';
import { ScreenResizeService } from '../services/screen-resize/screen-resize.service';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  private screenWidth: number = 1024;
  private mobileWidth: number = 767;

  constructor(private screenResizeService: ScreenResizeService) {
    super();

    this.screenResizeService.screenWidth$.subscribe((width) => {
      this.screenWidth = width;
      this.changes.next();
    });
  }

  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number,
  ): string => {
    if (
      (length === 0 || pageSize === 0) &&
      this.screenWidth > this.mobileWidth
    ) {
      return `0 de ${length} itens`;
    }
    if (
      (length === 0 || pageSize === 0) &&
      this.screenWidth < this.mobileWidth
    ) {
      return `0 - ${length}`;
    }
    const startIndex = page * pageSize + 1;
    const endIndex = Math.min((page + 1) * pageSize, length);

    if (this.screenWidth > this.mobileWidth) {
      return `${startIndex}–${endIndex} de ${length} itens`;
    }
    return `${startIndex}–${endIndex}`;
  };

  override itemsPerPageLabel = 'Itens por página';
}
